export default __webpack_public_path__ + "static/media/anagrafica.1c2370a2.less";